import React from 'react';
import { Grid } from '~/components';
import { MdFileDownload } from 'react-icons/md';
import { DropDown } from '~/components';
import { downloadResourceDocument } from './downloadResourceDocument';

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = {
    className: 'p-2 pr-4 border-b text-sm'
};


const TitleForm = ({titleFormData}) => {
    const columns = [
        { 
            title: 'Document Name', 
            field: 'description',
            headerClassName,
            props
        },
        {
            title: 'Action',
            canSort: false,
            cell: ({ data }) => {
                return (
                    <span className="flex justify-end">
                        <DropDown
                            wrapperClass="rounded-md border bg-white z-20 filter drop-shadow-xl right-1/4 top-full mt-1"
                            iconClass="text-white ml-2"
                            iconSize='1.25em'
                            buttonClass="py-1 pl-3 pr-2 bg-blue-50 text-white focus:outline-none rounded-full flex items-center justify-center"
                            text='Actions'>
                            <section className="flex flex-col items-stretch w-48 text-gray-80">
                                <p className="font-semibold text-sm p-4 py-2">Action</p>
                                <button className="btn btn-link py-2 px-4 hover:bg-blue-10 flex items-center" 
                                    onClick={() => onDownloadClick(data)}>
                                    <MdFileDownload />
                                    <span className="ml-2">Download </span>
                                </button>
                            </section>
                        </DropDown>
                    </span>
                );
            },
            headerClassName: headerClassName + ' pr-10 flex justify-end',
            props
        }
    ];

    const onDownloadClick = async(data) => {
        if(data?.documentId == undefined || data?.documentId == '') return;
        await downloadResourceDocument(data);
        
    };

    return (
        <React.Fragment>
            <div className="mb-4 w-44 w-full flex flex-row justify-between">
                <div className="justify-start flex flex-col">
                    <h2 className="text-2xl text-blue-60 font-bold mb-2">Title Forms</h2>
                </div>
            </div>
            <Grid 
                className='w-full'
                rowSelect
                data={titleFormData}
                columns={columns}
                usePagination={true}
            /> 
        </React.Fragment>
    );
};

export default TitleForm;